/*
 * MDB shim for MDBCardHeader
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/InlineTable.jsx
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/ShippingDetailsReport.jsx
 * - src/Seating/Reports/reports.jsx
 */

import MUICardHeader from "@mui/material/CardHeader";

export default function MDBCardHeader({
  children,
  title,
  className,
  style,
  ...rest
}) {
  return (
    <MUICardHeader
      title={title ?? children}
      className={className}
      style={style}
      {...rest}
    />
  );
}
